/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `UBC` - UBC
 * `ALUMINIUM_FOOD_CAN` - Aluminium Food Can
 * `UBC_AND_ALUMINIUM_FOOD_CAN` - UBC and Aluminium Food Can
 * `OTHER_ALUMINIUM` - Other Aluminium
 * `ALUMINIUM_FOIL_AND_TRAY` - Foil and Tray
 * `TOTAL_ALUMINIUM` - Total Aluminium
 * `NON_METAL` - Non Metal
 * `OTHER_METAL` - Other Metal
 * `FERROUS_METAL` - Ferrous Metal
 * `NON_ALUMINIUM` - Non-Aluminium
 * `PET_BOTTLES` - PET Bottles
 * `CLEAR_PET_BOTTLES` - Clear PET Bottles
 * `GREEN_PET_BOTTLES` - Green PET Bottles
 * `LIGHT_BLUE_PET_BOTTLES` - Light Blue PET Bottles
 * `DARK_BLUE_PET_BOTTLES` - Dark Blue PET Bottles
 * `CLEAR_AND_LIGHT_BLUE_PET_BOTTLES` - Clear and Light Blue PET Bottles
 * `OTHER_COLOURS` - PET Bottles Other Colours
 * `NON_PET_BOTTLES` - Non Pet Bottles
 * `TOTAL_IMPURITIES` - Total Impurities
 * `NON_FOOD_GRADE_BOTTLES` - Non Food Grade Bottles
 * `PET_TRAYS` - PET Trays
 * `FILM` - Film
 * `OTHER_PLASTIC` - Other Plastic
 * `METAL` - Metal
 * `NON_PLASTIC` - Non Plastic
 * `CLEAR_PET_FLAKES` - Clear PET Flakes
 * `LIGHT_BLUE_PET_FLAKES` - Light Blue PET Flakes
 * `CLEAR_AND_LIGHT_BLUE_PET_FLAKES` - Clear and Light Blue PET Flakes
 * `DARK_BLUE_PET_FLAKES` - Dark Blue PET Flakes
 * `GREEN_PET_FLAKES` - Green PET Flakes
 * `YELLOW_PET_FLAKES` - Yellow PET Flakes
 * `COLOURED_PET_FLAKES` - Coloured PET Flakes
 * `PARTICLE_SIZE_LT5MM` - Particle Size < 5mm
 * `PARTICLE_SIZE_5_10MM` - Particle Size 5-10mm
 * `PARTICLE_SIZE_10_12MM` - Particle Size 10-12mm
 * `PARTICLE_SIZE_GT12MM` - Particle Size > 12mm
 * `INTRINSIC_VISCOSITY` - Intrinsic Viscosity
 * `PVC` - PVC
 * `NON_FERROUS_METAL` - Non Ferrous Metal
 * `GLUE` - Glue
 * `MOISTURE` - Moisture
 * `ALUMINIUM_TT_ALUMINIUM` - Aluminium Taint Tabor
 * `ALUMINIUM_TT_CAST` - Cast Aluminium
 * `ALUMINIUM_TT_FINES` - Fines
 * `ALUMINIUM_TT_FOIL_UBC` - Foil/UBC
 * `ALUMINIUM_TT_RADIATOR` - Radiator
 * `ALUMINIUM_ZORBA_NON_FERROUS` - Non Ferrous
 * `ALUMINIUM_ZORBA_BRASS_OR_COPPER` - Brass or Copper
 * `ALUMINIUM_ZORBA_FINES` - Fines
 * `ALUMINIUM_ZORBA_NON_METAL` - Non Metal
 * `ALUMINIUM_ZORBA_UBC` - UBC
 * `ALUMINIUM_ZORBA_OTHER_METAL` - Other Metal
 */
export type QualityOutputMetricEnum = (typeof QualityOutputMetricEnum)[keyof typeof QualityOutputMetricEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualityOutputMetricEnum = {
  UBC: 'UBC',
  ALUMINIUM_FOOD_CAN: 'ALUMINIUM_FOOD_CAN',
  UBC_AND_ALUMINIUM_FOOD_CAN: 'UBC_AND_ALUMINIUM_FOOD_CAN',
  OTHER_ALUMINIUM: 'OTHER_ALUMINIUM',
  ALUMINIUM_FOIL_AND_TRAY: 'ALUMINIUM_FOIL_AND_TRAY',
  TOTAL_ALUMINIUM: 'TOTAL_ALUMINIUM',
  NON_METAL: 'NON_METAL',
  OTHER_METAL: 'OTHER_METAL',
  FERROUS_METAL: 'FERROUS_METAL',
  NON_ALUMINIUM: 'NON_ALUMINIUM',
  PET_BOTTLES: 'PET_BOTTLES',
  CLEAR_PET_BOTTLES: 'CLEAR_PET_BOTTLES',
  GREEN_PET_BOTTLES: 'GREEN_PET_BOTTLES',
  LIGHT_BLUE_PET_BOTTLES: 'LIGHT_BLUE_PET_BOTTLES',
  DARK_BLUE_PET_BOTTLES: 'DARK_BLUE_PET_BOTTLES',
  CLEAR_AND_LIGHT_BLUE_PET_BOTTLES: 'CLEAR_AND_LIGHT_BLUE_PET_BOTTLES',
  OTHER_COLOURS: 'OTHER_COLOURS',
  NON_PET_BOTTLES: 'NON_PET_BOTTLES',
  TOTAL_IMPURITIES: 'TOTAL_IMPURITIES',
  NON_FOOD_GRADE_BOTTLES: 'NON_FOOD_GRADE_BOTTLES',
  PET_TRAYS: 'PET_TRAYS',
  FILM: 'FILM',
  OTHER_PLASTIC: 'OTHER_PLASTIC',
  METAL: 'METAL',
  NON_PLASTIC: 'NON_PLASTIC',
  CLEAR_PET_FLAKES: 'CLEAR_PET_FLAKES',
  LIGHT_BLUE_PET_FLAKES: 'LIGHT_BLUE_PET_FLAKES',
  CLEAR_AND_LIGHT_BLUE_PET_FLAKES: 'CLEAR_AND_LIGHT_BLUE_PET_FLAKES',
  DARK_BLUE_PET_FLAKES: 'DARK_BLUE_PET_FLAKES',
  GREEN_PET_FLAKES: 'GREEN_PET_FLAKES',
  YELLOW_PET_FLAKES: 'YELLOW_PET_FLAKES',
  COLOURED_PET_FLAKES: 'COLOURED_PET_FLAKES',
  PARTICLE_SIZE_LT5MM: 'PARTICLE_SIZE_LT5MM',
  PARTICLE_SIZE_5_10MM: 'PARTICLE_SIZE_5_10MM',
  PARTICLE_SIZE_10_12MM: 'PARTICLE_SIZE_10_12MM',
  PARTICLE_SIZE_GT12MM: 'PARTICLE_SIZE_GT12MM',
  INTRINSIC_VISCOSITY: 'INTRINSIC_VISCOSITY',
  PVC: 'PVC',
  NON_FERROUS_METAL: 'NON_FERROUS_METAL',
  GLUE: 'GLUE',
  MOISTURE: 'MOISTURE',
  ALUMINIUM_TT_ALUMINIUM: 'ALUMINIUM_TT_ALUMINIUM',
  ALUMINIUM_TT_CAST: 'ALUMINIUM_TT_CAST',
  ALUMINIUM_TT_FINES: 'ALUMINIUM_TT_FINES',
  ALUMINIUM_TT_FOIL_UBC: 'ALUMINIUM_TT_FOIL_UBC',
  ALUMINIUM_TT_RADIATOR: 'ALUMINIUM_TT_RADIATOR',
  ALUMINIUM_ZORBA_NON_FERROUS: 'ALUMINIUM_ZORBA_NON_FERROUS',
  ALUMINIUM_ZORBA_BRASS_OR_COPPER: 'ALUMINIUM_ZORBA_BRASS_OR_COPPER',
  ALUMINIUM_ZORBA_FINES: 'ALUMINIUM_ZORBA_FINES',
  ALUMINIUM_ZORBA_NON_METAL: 'ALUMINIUM_ZORBA_NON_METAL',
  ALUMINIUM_ZORBA_UBC: 'ALUMINIUM_ZORBA_UBC',
  ALUMINIUM_ZORBA_OTHER_METAL: 'ALUMINIUM_ZORBA_OTHER_METAL',
} as const;
